"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import useAuthInfo from "@/store/auth";
import { AjaxGet, AjaxPost } from "@/util/Ajax";
import type { DiscoverItem } from "@/lib/discover";
import ListingCards from "../listing-cards";
import styles from "../discover.module.css";

export default function FollowingPage() {
  const auth = useAuthInfo(state => state);
  const [hydrated, setHydrated] = useState(false);
  const [items, setItems] = useState<DiscoverItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");
  useEffect(() => { void Promise.resolve(useAuthInfo.persist.rehydrate()).then(() => setHydrated(true)); }, []);
  useEffect(() => {
    if (!hydrated) return;
    let active = true;
    setItems([]); setError("");
    if (!auth.apiToken) { setLoading(false); return; }
    setLoading(true);
    void AjaxGet(auth, "Discover/Following").then(res => {
      if (!active) return;
      if (Array.isArray(res?.data)) setItems(res.data); else setError("Could not load the places you follow. Please try again.");
      setLoading(false);
    });
    return () => { active = false; };
  }, [hydrated, auth.apiToken]);
  const unfollow = async (id: string) => {
    setBusy(id); setError("");
    const res = await AjaxPost(auth, "Discover/Follow", { encListingId: id, follow: false, consent: false });
    if (res?.data?.following === false) setItems(current => current.filter(x => x.encryptedId !== id));
    else setError("Could not unfollow. Please try again.");
    setBusy("");
  };
  return <main className={styles.page}><section className={styles.heroSection}><div className={styles.container}>
    <Link href="/discover">← Discover businesses</Link><h1 className="text-4xl font-bold my-6">Places you follow</h1>
    <p>Receive email updates about services, promotions and specials. Unfollow a business to stop its updates and remove your details from its followers list.</p>
    {loading ? <p role="status">Loading…</p> : !auth.apiToken ? <p className="mt-6"><Link href="/login">Sign in to view the places you follow</Link></p> : <>
      {error && <p role="alert" className="mt-6">{error}</p>}
      {!items.length && !error && <p className="mt-6">You do not follow any businesses yet. Explore Discover and follow your favourites.</p>}
      <ListingCards items={items} /><div className="mt-6 space-y-3">{items.map(item => <div key={item.encryptedId} className="flex items-center justify-between gap-4 border-b py-3"><span>{item.title}</span><button type="button" className="underline" disabled={Boolean(busy)} onClick={() => void unfollow(item.encryptedId)}>{busy === item.encryptedId ? "Updating…" : "Unfollow"}</button></div>)}</div>
    </>}
  </div></section></main>;
}
